import { Link, useOutletContext } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHeader } from "@/components/site/PageHeader";
import { OfferCard } from "@/components/home/OffersSection";
import { TestDriveCTA } from "@/components/home/TestDriveCTA";
import { Stagger, Item, Reveal } from "@/components/motion/Reveal";

export default function Offers() {
  const { offers, vehicles } = useOutletContext();
  return (
    <div data-testid="offers-page">
      <PageHeader
        eyebrow="Offers"
        lines={["Deals worth", "the drive."]}
        sub="Every live promotion at West Canal Motors, in one place. Offers apply to bookings made at our West Canal Road showroom."
      />
      <section className="wrap pb-24 sm:pb-32">
        {offers.length ? (
          <Stagger className="grid gap-4" gap={0.12}>
            {offers.map((o) => (
              <Item key={o.id}>
                <OfferCard offer={o} vehicle={vehicles.find((v) => v.slug === o.vehicle_slug)} wide showTerms />
              </Item>
            ))}
          </Stagger>
        ) : (
          <Reveal className="border border-white/10 bg-surface p-10 sm:p-16 text-center" data-testid="offers-empty">
            <p className="eyebrow">No live offers right now</p>
            <h2 className="display-lg mt-4">Check back <span className="font-editorial italic font-normal normal-case tracking-normal text-gold">soon.</span></h2>
            <p className="mx-auto mt-6 max-w-md text-slate-400">New promotions are announced here first. In the meantime, our team can walk you through current ex-factory pricing.</p>
            <Link to="/contact" className="btn-crimson mt-8">Talk to sales <ArrowUpRight className="h-4 w-4" /></Link>
          </Reveal>
        )}
      </section>
      <TestDriveCTA vehicle={vehicles[0]} />
    </div>
  );
}
